export default "__VITE_ASSET__B$$No2Sd__"